import { render, staticRenderFns } from "./EmailFilter.vue?vue&type=template&id=a4aa377c"
import script from "./EmailFilter.vue?vue&type=script&lang=js"
export * from "./EmailFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports